import React, { useEffect, useRef, useState } from 'react';
import { useSessionState } from '../hooks/useSessionState';
import RibbonActions from '../components/RibbonActions';
import {
  getFacturasRecibidas, uploadFacturaRecibida,
  getAsientoPreview, contabilizarRecibida, descontabilizarRecibida,
  getRetencionesConfig, getFacturaRecibidaPDF,
  getFacturaRecibida, setRecibidaItemsTipo, setRecibidaItemsRetencion, autoClasificarRecibida, autoClasificarTodoRecibidas, setRecibidaNoDescontable,
  getEventosRecibida, crearEventoRecibida, enviarEventoRecibida, xmlEventoRecibidaUrl,
} from '../services/api';
import FiltroPanel from '../components/FiltroPanel';
import BuzonesModal from '../components/BuzonesModal';
import EntradaBodegaModal from '../components/EntradaBodegaModal';

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
const fdate = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';

// Iconos de acción (una sola línea en la columna de acciones)
const IconBtn = ({ title, onClick, color = '#94a3b8', children }) => (
  <button title={title} onClick={onClick}
    style={{ background: 'none', border: 'none', cursor: 'pointer', color, padding: 6, borderRadius: 6, display: 'inline-flex', lineHeight: 0 }}
    onMouseEnter={e => (e.currentTarget.style.background = '#33415577')}
    onMouseLeave={e => (e.currentTarget.style.background = 'none')}>
    {children}
  </button>
);
const IC = {
  pdf: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="15" x2="15" y2="15"/></svg>,
  cont: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="10" y2="10"/><line x1="12" y1="10" x2="16" y2="10"/><line x1="8" y1="14" x2="10" y2="14"/><line x1="8" y1="18" x2="10" y2="18"/></svg>,
  descont: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7v6h6"/><path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"/></svg>,
  radian: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="2"/><path d="M16.24 7.76a6 6 0 0 1 0 8.49M7.76 16.24a6 6 0 0 1 0-8.49M19.07 4.93a10 10 0 0 1 0 14.14M4.93 19.07a10 10 0 0 1 0-14.14"/></svg>,
  tag: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>,
  nodesc: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>,
  bodega: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21V8l9-5 9 5v13"/><path d="M3 21h18"/><rect x="7" y="13" width="10" height="8"/><line x1="7" y1="17" x2="17" y2="17"/></svg>,
  mail: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 6L2 7"/></svg>,
};
const TIPO = { '01': 'Factura', '91': 'Nota Crédito', '92': 'Nota Débito' };
const EST = {
  recibida: { l: 'Recibida', c: '#94a3b8' }, acusada: { l: 'Acusada', c: '#3b82f6' },
  recibida_bien: { l: 'Recibido', c: '#8b5cf6' }, aceptada: { l: 'Aceptada', c: '#10b981' }, reclamada: { l: 'Reclamada', c: '#ef4444' },
};

export default function FacturasRecibidas() {
  const [lista, setLista] = useState([]);
  const [subiendo, setSubiendo] = useState(false);
  const [msg, setMsg] = useState(null);
  const [cont, setCont] = useState(null);   // factura en contabilización
  const [radian, setRadian] = useState(null); // factura en eventos RADIAN
  const [clasif, setClasif] = useState(null); // factura en clasificación bien/servicio
  const [bodega, setBodega] = useState(null); // factura en envío a bodega
  const [autoBusy, setAutoBusy] = useState(false);
  const [retCfg, setRetCfg] = useState(null);
  const [buzOpen, setBuzOpen] = useState(false);
  const [fil, setFil] = useSessionState('frec_fil', { q: '', contable: '', tipo: '', anio: '' });
  const fileRef = useRef(null);

  const load = () => getFacturasRecibidas().then(r => setLista(r.data)).catch(() => {});
  const loadCfg = () => getRetencionesConfig().then(r => setRetCfg(r.data)).catch(() => {});
  useEffect(() => { load(); loadCfg(); }, []);
  const flash = (ok, text) => { setMsg({ ok, text }); setTimeout(() => setMsg(null), 4500); };

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSubiendo(true); setMsg(null);
    try {
      const fd = new FormData(); fd.append('archivo', file);
      const { data } = await uploadFacturaRecibida(fd);
      flash(true, data.duplicada ? `Ya estaba cargada: ${data.resumen.emisor} · ${data.resumen.numero}` : `✅ Cargada: ${data.resumen.emisor} · ${data.resumen.numero} · ${fmt(data.resumen.total)}`);
      load();
    } catch (err) { flash(false, '❌ ' + (err.response?.data?.error || 'No se pudo procesar el archivo')); }
    finally { setSubiendo(false); if (fileRef.current) fileRef.current.value = ''; }
  };

  const verPdf = async (f) => {
    try {
      const { data } = await getFacturaRecibidaPDF(f.id);
      const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (err) { flash(false, '❌ No se pudo generar el PDF'); }
  };

  const descontabilizar = async (f) => {
    if (!window.confirm(`¿Descontabilizar la factura ${f.numero}? Se elimina su comprobante.`)) return;
    try { await descontabilizarRecibida(f.id); load(); flash(true, 'Comprobante revertido'); }
    catch (err) { flash(false, '❌ ' + (err.response?.data?.error || 'No se pudo')); }
  };

  const toggleNoDesc = async (f) => {
    const nuevo = !f.no_descontable;
    if (nuevo && !window.confirm(`Marcar el IVA de ${f.emisor_nombre} ${f.numero} como NO descontable. Dejará de sumar al IVA descontable en la liquidación. ¿Continuar?`)) return;
    try { await setRecibidaNoDescontable(f.id, nuevo); load(); flash(true, nuevo ? '✅ Marcada como IVA no descontable' : '✅ IVA descontable restablecido'); }
    catch (err) { flash(false, '❌ ' + (err.response?.data?.error || 'No se pudo')); }
  };

  const autoClasificarTodo = async () => {
    if (!window.confirm('Auto-clasificar bienes/servicios en TODAS las facturas recibidas. Respeta lo que ya marcaste a mano. ¿Continuar?')) return;
    setAutoBusy(true);
    try { const { data } = await autoClasificarTodoRecibidas(); flash(true, `✅ ${data.clasificados} ítems auto-clasificados`); }
    catch (err) { flash(false, '❌ ' + (err.response?.data?.error || 'No se pudo')); }
    finally { setAutoBusy(false); }
  };

  const anios = [...new Set(lista.map(f => f.fecha_emision ? new Date(f.fecha_emision).getFullYear() : null).filter(Boolean))].sort((a, b) => b - a);
  const filtrada = lista.filter(f => {
    if (fil.q) { const s = fil.q.toLowerCase(); if (!`${f.emisor_nombre || ''} ${f.emisor_nit || ''} ${f.numero || ''}`.toLowerCase().includes(s)) return false; }
    if (fil.contable && (f.estado_contable || 'pendiente') !== fil.contable) return false;
    if (fil.tipo && f.tipo !== fil.tipo) return false;
    if (fil.anio && (!f.fecha_emision || String(new Date(f.fecha_emision).getFullYear()) !== fil.anio)) return false;
    return true;
  });
  const totalFiltrado = filtrada.reduce((a, f) => a + Number(f.total || 0), 0);

  return (
    <div style={s.wrap}>
      <div style={s.head}>
        <div>
          <h1 style={s.h1}>Facturas recibidas</h1>
          <p style={s.sub}>Recepción de facturas de proveedores (DIAN) y su causación contable.</p>
        </div>
        <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <FiltroPanel
            fields={[
              { tipo: 'input', label: 'Buscar', value: fil.q, onChange: v => setFil({ ...fil, q: v }), placeholder: 'Proveedor, NIT o número…', width: 210 },
              { tipo: 'select', label: 'Contable', value: fil.contable, onChange: v => setFil({ ...fil, contable: v }), options: [{ value: '', label: 'Todas' }, { value: 'pendiente', label: 'Pendientes' }, { value: 'contabilizada', label: 'Contabilizadas' }] },
              { tipo: 'select', label: 'Tipo', value: fil.tipo, onChange: v => setFil({ ...fil, tipo: v }), options: [{ value: '', label: 'Todos' }, { value: '01', label: 'Factura' }, { value: '91', label: 'Nota Crédito' }, { value: '92', label: 'Nota Débito' }] },
              { tipo: 'select', label: 'Año', value: fil.anio, onChange: v => setFil({ ...fil, anio: v }), options: [{ value: '', label: 'Todos' }, ...anios.map(a => ({ value: String(a), label: String(a) }))] },
            ]}
            onClear={() => setFil({ q: '', contable: '', tipo: '', anio: '' })}
          />
          <button style={s.btnGhost} onClick={() => setBuzOpen(true)}><span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>{IC.mail} Buzones</span></button>
          <button style={s.btnGhost} disabled={autoBusy} onClick={autoClasificarTodo}>{autoBusy ? 'Clasificando…' : '🤖 Auto-clasificar'}</button>
          <input ref={fileRef} type="file" accept=".zip,.xml" style={{ display: 'none' }} onChange={onFile} />
          <button style={s.btn} disabled={subiendo} onClick={() => fileRef.current?.click()}>{subiendo ? 'Procesando…' : '📥 Cargar factura (ZIP/XML)'}</button>
        </div></RibbonActions>
        <span style={{ ...s.fCount, alignSelf: 'flex-end' }}>{filtrada.length} de {lista.length} · {fmt(totalFiltrado)}</span>
      </div>

      {msg && <div style={{ ...s.msg, background: msg.ok ? '#064e3b' : '#450a0a', color: msg.ok ? '#6ee7b7' : '#fca5a5' }}>{msg.text}</div>}

      <div style={s.card}><div style={{ overflowX: 'auto' }}>
        <table style={s.table}>
          <thead><tr>{['Proveedor', 'Tipo', 'Número', 'Fecha', 'Total', 'Estado', 'Contable', ''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {filtrada.length === 0 && <tr><td colSpan={8} style={s.empty}>{lista.length ? 'Ninguna factura coincide con el filtro.' : 'Sin facturas recibidas.'}</td></tr>}
            {filtrada.map(f => {
              const e = EST[f.estado] || EST.recibida;
              const cble = f.estado_contable === 'contabilizada';
              return (
                <tr key={f.id}>
                  <td style={{ ...s.td, fontWeight: 600, color: '#e2e8f0' }}>{f.emisor_nombre}<div style={{ color: '#64748b', fontSize: 11 }}>{f.emisor_nit}</div></td>
                  <td style={s.td}>{TIPO[f.tipo] || f.tipo}</td>
                  <td style={s.td}>{f.numero}{f.no_descontable && <span style={{ marginLeft: 6, fontSize: 10, color: '#f87171', background: '#450a0a', border: '1px solid #b91c1c', borderRadius: 4, padding: '1px 5px', whiteSpace: 'nowrap' }}>IVA no desc.</span>}</td>
                  <td style={s.td}>{fdate(f.fecha_emision)}</td>
                  <td style={{ ...s.td, fontWeight: 700 }}>{fmt(f.total)}</td>
                  <td style={s.td}><span style={{ ...s.badge, background: e.c + '22', color: e.c }}>{e.l}</span></td>
                  <td style={s.td}><span style={{ ...s.badge, background: cble ? '#10b98122' : '#64748b22', color: cble ? '#10b981' : '#94a3b8' }}>{cble ? 'Contabilizada' : 'Pendiente'}</span></td>
                  <td style={s.td}>
                    <div style={{ display: 'flex', gap: 2, justifyContent: 'flex-end', whiteSpace: 'nowrap' }}>
                      <IconBtn title="Ver PDF" color="#60a5fa" onClick={() => verPdf(f)}>{IC.pdf}</IconBtn>
                      {cble
                        ? <IconBtn title="Descontabilizar" color="#fca5a5" onClick={() => descontabilizar(f)}>{IC.descont}</IconBtn>
                        : <IconBtn title="Contabilizar" color="#34d399" onClick={() => setCont(f)}>{IC.cont}</IconBtn>}
                      <IconBtn title="Clasificar bienes/servicios" color="#fbbf24" onClick={() => setClasif(f)}>{IC.tag}</IconBtn>
                      <IconBtn title="Enviar productos a una bodega" color="#38bdf8" onClick={() => setBodega(f)}>{IC.bodega}</IconBtn>
                      <IconBtn title={f.no_descontable ? 'IVA marcado como NO descontable — clic para restablecer' : 'Marcar IVA como no descontable'} color={f.no_descontable ? '#f87171' : '#64748b'} onClick={() => toggleNoDesc(f)}>{IC.nodesc}</IconBtn>
                      <IconBtn title="Eventos RADIAN" color="#a78bfa" onClick={() => setRadian(f)}>{IC.radian}</IconBtn>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div></div>

      {cont && <ContabilizarModal factura={cont} retCfg={retCfg} onClose={() => setCont(null)} onDone={() => { setCont(null); load(); flash(true, '✅ Factura contabilizada'); }} onError={(t) => flash(false, '❌ ' + t)} />}
      {radian && <EventosModal factura={radian} onClose={() => setRadian(null)} onError={(t) => flash(false, '❌ ' + t)} onFlash={flash} />}
      {bodega && <EntradaBodegaModal factura={bodega} onClose={() => setBodega(null)} onFlash={flash} />}
      {clasif && <ClasificarModal factura={clasif} onClose={() => setClasif(null)} onDone={() => { setClasif(null); flash(true, '✅ Ítems clasificados'); }} onError={(t) => flash(false, '❌ ' + t)} />}
      {buzOpen && <BuzonesModal soloTipo="factura" onClose={() => setBuzOpen(false)} onFlash={flash} />}
    </div>
  );
}

// Modal para clasificar los ítems de una compra como bien / servicio (para la declaración de IVA).
function ClasificarModal({ factura, onClose, onDone, onError }) {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getFacturaRecibida(factura.id)
      .then(r => setItems((r.data.items || []).map(it => ({
        ...it, tipo_item: it.tipo_item || 'bien',
        descuento_valor: Number(it.descuento_valor) || 0,
        retefuente_pct: (it.retefuente_pct === null || it.retefuente_pct === undefined) ? '' : Number(it.retefuente_pct),
      }))))
      .catch(() => onError('No se pudieron cargar los ítems'));
    // eslint-disable-next-line
  }, [factura.id]);

  // Tarifa efectiva de la línea: la fijada, o la derivada de bien/servicio.
  const RATE_BY_TIPO = { bien: 2.5, servicio: 4 };
  const efRate = (it) => (it.retefuente_pct !== '' && it.retefuente_pct != null) ? Number(it.retefuente_pct) : (RATE_BY_TIPO[it.tipo_item] ?? 0);
  const baseLinea = (it) => Math.max(0, (Number(it.cantidad) || 0) * (Number(it.precio_unitario) || 0) - (Number(it.descuento_valor) || 0));
  // Retención agrupada por tarifa (para mostrar en vivo).
  const grupos = {};
  (items || []).forEach(it => { const t = efRate(it); if (!t) return; grupos[t] = (grupos[t] || 0) + baseLinea(it) * t / 100; });
  const gruposArr = Object.entries(grupos).map(([t, v]) => ({ tarifa: Number(t), valor: Math.round(v) })).sort((a, b) => b.tarifa - a.tarifa);
  const retefTotal = gruposArr.reduce((s, g) => s + g.valor, 0);
  const subtotalBase = (items || []).reduce((s, it) => s + baseLinea(it), 0);
  const ivaTotal = (items || []).reduce((s, it) => s + baseLinea(it) * (Number(it.iva_pct) || 0) / 100, 0);

  const setTipo = (id, tipo) => setItems(its => its.map(it => it.id === id ? { ...it, tipo_item: tipo, origen_clasificacion: 'manual' } : it));
  const setDesc = (id, v) => setItems(its => its.map(it => it.id === id ? { ...it, descuento_valor: v } : it));
  const setRetef = (id, v) => setItems(its => its.map(it => it.id === id ? { ...it, retefuente_pct: v } : it));
  const todos = (tipo) => setItems(its => its.map(it => ({ ...it, tipo_item: tipo, origen_clasificacion: 'manual' })));

  const [autoBusy, setAutoBusy] = useState(false);
  const autoClasif = async () => {
    setAutoBusy(true);
    try {
      const { data } = await autoClasificarRecibida(factura.id);
      setItems((data.items || []).map(it => ({ ...it, tipo_item: it.tipo_item || 'bien' })));
    } catch (e) { onError('No se pudo auto-clasificar'); }
    finally { setAutoBusy(false); }
  };

  const guardar = async () => {
    setBusy(true);
    try {
      await setRecibidaItemsTipo(factura.id, { items: items.map(it => ({ id: it.id, tipo_item: it.tipo_item })) });
      await setRecibidaItemsRetencion(factura.id, { items: items.map(it => ({
        id: it.id, descuento_valor: Number(it.descuento_valor) || 0, retefuente_pct: efRate(it), concepto_ret: it.concepto_ret || null,
      })) });
      onDone();
    } catch (e) { onError(e.response?.data?.error || 'No se pudo guardar'); }
    finally { setBusy(false); }
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.modal, width: 780, maxHeight: '92vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <h3 style={s.modalTitle}>Clasificar bienes / servicios · {factura.emisor_nombre} {factura.numero}</h3>
        <p style={{ color: '#94a3b8', fontSize: 12.5, margin: '0 0 12px' }}>Marca cada ítem como bien o servicio, el descuento y la tarifa de retefuente (se hereda: bien 2.5% / servicio 4%; cámbiala para combustibles 0.1% u otros). Abajo ves la retención agrupada por tarifa.</p>
        {items === null ? <p style={{ color: '#64748b' }}>Cargando…</p> : items.length === 0 ? <p style={{ color: '#64748b' }}>Esta factura no tiene ítems detallados.</p> : (
          <>
            <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
              <button style={s.btn} disabled={autoBusy} onClick={autoClasif}>{autoBusy ? 'Clasificando…' : '🤖 Auto-clasificar'}</button>
              <button style={s.btnGhost} onClick={() => todos('bien')}>Todos: Bien</button>
              <button style={s.btnGhost} onClick={() => todos('servicio')}>Todos: Servicio</button>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr>{['Descripción', 'IVA', 'Desc.', 'Retef. %', 'Tipo'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {items.map(it => (
                  <tr key={it.id}>
                    <td style={{ ...s.td, fontSize: 12.5 }}>{it.descripcion}</td>
                    <td style={{ ...s.td, whiteSpace: 'nowrap' }}>{Number(it.iva_pct || 0)}%</td>
                    <td style={s.td}>
                      <input type="number" value={it.descuento_valor} onChange={e => setDesc(it.id, e.target.value)}
                        style={{ width: 80, background: '#0f172a', border: '1px solid #334155', borderRadius: 6, padding: '5px 8px', color: '#f1f5f9', fontSize: 12.5, textAlign: 'right' }} />
                    </td>
                    <td style={s.td}>
                      <input type="number" step="0.1" value={it.retefuente_pct === '' ? efRate(it) : it.retefuente_pct}
                        onChange={e => setRetef(it.id, e.target.value)}
                        title="Tarifa de retefuente de la línea (se hereda de bien/servicio; cámbiala para combustibles 0.1% u otros)"
                        style={{ width: 64, background: '#0f172a', border: '1px solid #334155', borderRadius: 6, padding: '5px 8px', color: '#f1f5f9', fontSize: 12.5, textAlign: 'right' }} />
                    </td>
                    <td style={s.td}>
                      <select value={it.tipo_item} onChange={e => setTipo(it.id, e.target.value)}
                        style={{ background: '#0f172a', border: '1px solid #334155', borderRadius: 6, padding: '5px 8px', color: '#f1f5f9', fontSize: 12.5 }}>
                        <option value="bien">Bien</option>
                        <option value="servicio">Servicio</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ marginTop: 12, borderTop: '1px solid #334155', paddingTop: 10, fontSize: 13 }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 24, color: '#94a3b8' }}>
                <span>Subtotal: <b style={{ color: '#e2e8f0' }}>${Math.round(subtotalBase).toLocaleString('es-CO')}</b></span>
                <span>IVA: <b style={{ color: '#e2e8f0' }}>${Math.round(ivaTotal).toLocaleString('es-CO')}</b></span>
              </div>
              {gruposArr.map(g => (
                <div key={g.tarifa} style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, color: '#fca5a5', marginTop: 2 }}>
                  <span>Retefuente {g.tarifa}%:</span><b>−${g.valor.toLocaleString('es-CO')}</b>
                </div>
              ))}
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 6, fontSize: 14 }}>
                <span style={{ color: '#94a3b8' }}>Total a pagar:</span>
                <b style={{ color: '#34d399' }}>${Math.round(subtotalBase + ivaTotal - retefTotal).toLocaleString('es-CO')}</b>
              </div>
            </div>
          </>
        )}
        <div style={s.modalBtns}>
          <button style={s.btnGhost} onClick={onClose}>Cerrar</button>
          {items && items.length > 0 && <button style={s.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button>}
        </div>
      </div>
    </div>
  );
}


const EVENTOS_META = {
  '030': { l: 'Acuse de recibo', desc: 'Confirma que recibiste la factura' },
  '032': { l: 'Recibo del bien/servicio', desc: 'Confirma que recibiste la mercancía o servicio' },
  '033': { l: 'Aceptación expresa', desc: 'Aceptas la factura (queda exigible)' },
  '031': { l: 'Reclamo', desc: 'Rechazas la factura' },
};

function EventosModal({ factura, onClose, onError, onFlash }) {
  const [lista, setLista] = useState([]);
  const [busy, setBusy] = useState('');
  const load = () => getEventosRecibida(factura.id).then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const registrar = async (codigo) => {
    const meta = EVENTOS_META[codigo];
    if (!window.confirm(`Registrar "${meta.l}" ante la DIAN (PRODUCCIÓN) sobre la factura ${factura.numero} de ${factura.emisor_nombre}. Es un documento legal. ¿Continuar?`)) return;
    setBusy(codigo);
    try {
      const { data: ev } = await crearEventoRecibida(factura.id, { codigo });
      const { data: res } = await enviarEventoRecibida(ev.id);
      if (res.isValid) onFlash(true, `✅ ${meta.l} aceptado por la DIAN`);
      else onError(`DIAN rechazó (${res.statusCode}): ${(res.errorMessages || []).join(' · ') || res.statusMessage}`);
      load();
    } catch (e) { onError(e.response?.data?.error || 'No se pudo registrar'); }
    finally { setBusy(''); }
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.modal, width: 560 }} onClick={e => e.stopPropagation()}>
        <h3 style={s.modalTitle}>Eventos RADIAN · {factura.emisor_nombre} {factura.numero}</h3>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>
          {Object.entries(EVENTOS_META).map(([cod, m]) => (
            <button key={cod} title={m.desc} disabled={!!busy} style={{ ...s.btnGhost, borderColor: cod === '031' ? '#7f1d1d' : '#334155', color: cod === '031' ? '#fca5a5' : '#cbd5e1' }} onClick={() => registrar(cod)}>
              {busy === cod ? 'Enviando…' : m.l}
            </button>
          ))}
        </div>
        <div style={s.card}><table style={{ ...s.table, minWidth: 0 }}>
          <thead><tr>{['Evento', 'Fecha', 'Estado DIAN', 'XML'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={4} style={s.empty}>Sin eventos registrados.</td></tr>}
            {lista.map(e => (
              <tr key={e.id}>
                <td style={s.td}>{EVENTOS_META[e.evento_codigo]?.l || e.evento_codigo}</td>
                <td style={s.td}>{fdate(e.dian_enviado_at || e.created_at)}</td>
                <td style={s.td}><span style={{ ...s.badge, background: e.estado === 'aceptado' ? '#10b98122' : e.estado === 'rechazado' ? '#ef444422' : '#64748b22', color: e.estado === 'aceptado' ? '#10b981' : e.estado === 'rechazado' ? '#ef4444' : '#94a3b8' }}>{e.estado}</span>{e.dian_status_msg && e.estado === 'rechazado' ? <div style={{ fontSize: 10, color: '#f87171', marginTop: 3 }}>{e.dian_status_msg}</div> : null}</td>
                <td style={s.td}>{e.xml_firmado !== null ? <a href={xmlEventoRecibidaUrl(e.id)} style={s.link}>XML</a> : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table></div>
        <div style={s.modalBtns}><button style={s.btnGhost} onClick={onClose}>Cerrar</button></div>
      </div>
    </div>
  );
}

function ContabilizarModal({ factura, retCfg, onClose, onDone, onError }) {
  const [pv, setPv] = useState(null);
  const [gasto, setGasto] = useState('');
  const [ret, setRet] = useState({ retefuente: 0, reteiva: 0, reteica: 0 });
  const [concepto, setConcepto] = useState('no_aplica');
  const [declarante, setDeclarante] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => { getAsientoPreview(factura.id).then(r => { setPv(r.data); setGasto(r.data.cuentas.gasto || ''); }).catch(() => onError('No se pudo cargar')); /* eslint-disable-next-line */ }, []);

  // Autocálculo de retenciones al elegir concepto / declarante (se puede editar luego).
  useEffect(() => {
    if (!pv || !retCfg) return;
    const F = pv.factura, base = F.subtotal, uvt = retCfg.uvt || 0;
    const c = (retCfg.conceptos || []).find(x => x.cod === concepto);
    if (!c) return;
    const tarifa = declarante ? c.tarifa : c.tarifa_nd;
    const rf = (c.base_uvt > 0 && base < c.base_uvt * uvt) ? 0 : Math.round(base * tarifa / 100);
    const ri = (retCfg.agente_reteiva && F.impuestos > 0 && c.cod !== 'no_aplica') ? Math.round(F.impuestos * (retCfg.reteiva_pct || 0) / 100) : 0;
    const rc = (retCfg.reteica_tarifa > 0 && c.cod !== 'no_aplica') ? Math.round(base * retCfg.reteica_tarifa / 1000) : 0;
    setRet({ retefuente: rf, reteiva: ri, reteica: rc });
  }, [concepto, declarante, pv, retCfg]);

  if (!pv) return <div style={s.overlay}><div style={s.modal}>Cargando…</div></div>;
  const F = pv.factura, C = pv.cuentas;
  const rf = +ret.retefuente || 0, ri = +ret.reteiva || 0, rc = +ret.reteica || 0;
  const crProv = +(F.total - rf - ri - rc).toFixed(2);
  const lineas = [
    { c: gasto, d: F.subtotal, cr: 0, t: 'Gasto / costo (base)' },
    ...(F.impuestos > 0 ? [{ c: C.iva_descontable, d: F.impuestos, cr: 0, t: 'IVA descontable' }] : []),
    { c: C.proveedores, d: 0, cr: crProv, t: 'Proveedores' },
    ...(rf > 0 ? [{ c: C.retefuente, d: 0, cr: rf, t: 'Retefuente' }] : []),
    ...(ri > 0 ? [{ c: C.reteiva, d: 0, cr: ri, t: 'ReteIVA' }] : []),
    ...(rc > 0 ? [{ c: C.reteica, d: 0, cr: rc, t: 'ReteICA' }] : []),
  ];
  const inv = factura.tipo === '91';
  const td = lineas.reduce((a, l) => a + (inv ? l.cr : l.d), 0);
  const tc = lineas.reduce((a, l) => a + (inv ? l.d : l.cr), 0);

  const confirmar = async () => {
    if (!gasto) return onError('Indica la cuenta de gasto/costo');
    setBusy(true);
    try { await contabilizarRecibida(factura.id, { cuenta_gasto: gasto, ...ret }); onDone(); }
    catch (e) { onError(e.response?.data?.error || 'No se pudo contabilizar'); setBusy(false); }
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.modal, width: 620 }} onClick={e => e.stopPropagation()}>
        <h3 style={s.modalTitle}>Contabilizar · {factura.emisor_nombre} {factura.numero}</h3>
        {inv && <div style={s.warn}>Nota crédito: el asiento se registra invertido (reduce la cuenta por pagar).</div>}
        <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginBottom: 12, fontSize: 13, color: '#94a3b8' }}>
          <span>Subtotal <b style={{ color: '#e2e8f0' }}>{fmt(F.subtotal)}</b></span>
          <span>IVA <b style={{ color: '#e2e8f0' }}>{fmt(F.impuestos)}</b></span>
          <span>Total <b style={{ color: '#e2e8f0' }}>{fmt(F.total)}</b></span>
        </div>

        <label style={s.lbl}>Cuenta de gasto / costo (base)</label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          <input style={{ ...s.in, flex: 1 }} value={gasto} onChange={e => setGasto(e.target.value)} placeholder="Código PUC" />
          {C.gasto && <button style={s.chip} onClick={() => setGasto(C.gasto)}>Costo bienes {C.gasto}</button>}
          {C.gasto_servicios && <button style={s.chip} onClick={() => setGasto(C.gasto_servicios)}>Servicios {C.gasto_servicios}</button>}
        </div>

        <label style={s.lbl}>Concepto de retención en la fuente</label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
          <select style={{ ...s.in, flex: 1, minWidth: 180 }} value={concepto} onChange={e => setConcepto(e.target.value)}>
            {(retCfg?.conceptos || [{ cod: 'no_aplica', nombre: 'No aplica' }]).map(c => <option key={c.cod} value={c.cod}>{c.nombre}</option>)}
          </select>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#94a3b8', fontSize: 12.5, whiteSpace: 'nowrap' }}>
            <input type="checkbox" checked={declarante} onChange={e => setDeclarante(e.target.checked)} />Proveedor declarante
          </label>
        </div>
        <label style={s.lbl}>Retenciones (autocalculadas — puedes ajustarlas)</label>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 14 }}>
          {[['retefuente', 'Retefuente'], ['reteiva', 'ReteIVA'], ['reteica', 'ReteICA']].map(([k, l]) =>
            <div key={k}><div style={{ ...s.lbl, fontSize: 11 }}>{l}</div><input type="number" style={s.in} value={ret[k]} onChange={e => setRet({ ...ret, [k]: e.target.value })} /></div>)}
        </div>

        <div style={s.sec}>Asiento a generar</div>
        <div style={s.card}><table style={{ ...s.table, minWidth: 0 }}>
          <thead><tr>{['Cuenta', 'Concepto', 'Débito', 'Crédito'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lineas.map((l, i) => (
              <tr key={i}>
                <td style={{ ...s.td, fontFamily: 'ui-monospace' }}>{l.c || <span style={{ color: '#ef4444' }}>—</span>}</td>
                <td style={s.td}>{l.t}</td>
                <td style={{ ...s.td, textAlign: 'right', fontFamily: 'ui-monospace' }}>{(inv ? l.cr : l.d) ? fmt(inv ? l.cr : l.d) : ''}</td>
                <td style={{ ...s.td, textAlign: 'right', fontFamily: 'ui-monospace' }}>{(inv ? l.d : l.cr) ? fmt(inv ? l.d : l.cr) : ''}</td>
              </tr>
            ))}
            <tr><td style={{ ...s.td, fontWeight: 700 }} colSpan={2}>Totales</td>
              <td style={{ ...s.td, textAlign: 'right', fontWeight: 700, fontFamily: 'ui-monospace' }}>{fmt(td)}</td>
              <td style={{ ...s.td, textAlign: 'right', fontWeight: 700, fontFamily: 'ui-monospace' }}>{fmt(tc)}</td></tr>
          </tbody>
        </table></div>
        <div style={{ fontSize: 12, color: Math.abs(td - tc) < 0.02 ? '#10b981' : '#ef4444', marginTop: 6 }}>{Math.abs(td - tc) < 0.02 ? '✓ El asiento cuadra' : '✗ Descuadrado'}</div>

        <div style={s.modalBtns}>
          <button style={s.btnGhost} onClick={onClose}>Cancelar</button>
          <button style={s.btn} disabled={busy || Math.abs(td - tc) >= 0.02} onClick={confirmar}>{busy ? 'Contabilizando…' : 'Contabilizar'}</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  wrap: { padding: 4 },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6, flexWrap: 'wrap', gap: 12 },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  btn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '10px 18px', fontSize: 14, cursor: 'pointer' },
  msg: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 },
  filtros: { display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 12 },
  fInput: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 11px', color: '#f1f5f9', fontSize: 13 },
  fCount: { marginLeft: 'auto', color: '#64748b', fontSize: 12, fontFamily: 'ui-monospace,monospace', whiteSpace: 'nowrap' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 760 },
  th: { textAlign: 'left', padding: '10px 12px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155', background: '#0f172a', whiteSpace: 'nowrap' },
  td: { padding: '10px 12px', color: '#94a3b8', borderBottom: '1px solid #1e293b' },
  empty: { padding: 30, textAlign: 'center', color: '#64748b' },
  badge: { padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, padding: 0 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18, width: 420, maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', color: '#cbd5e1' },
  modalTitle: { color: '#f1f5f9', fontSize: 17, fontWeight: 700, margin: '0 0 12px' },
  modalBtns: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 12 },
  lbl: { display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 5 },
  in: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 11px', color: '#f1f5f9', fontSize: 13.5 },
  chip: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '4px 10px', color: '#93c5fd', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap' },
  sec: { color: '#f59e0b', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: .6, margin: '14px 0 8px' },
  warn: { background: '#3a2c10', color: '#e0a343', fontSize: 12, padding: '8px 12px', borderRadius: 8, marginBottom: 12 },
};
